"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

var _redial = require("redial");

var _reactRedux = require("react-redux");

var _glamor = require("glamor");

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Columns = require("@quixeltools/quixel-ui-library/dist/components/common/website/Columns");

var _Columns2 = _interopRequireDefault(_Columns);

var _Slider = require("@quixeltools/quixel-ui-library/dist/components/common/website/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _NewsItem = require("@quixeltools/quixel-ui-library/dist/components/common/blog/NewsItem");

var _NewsItem2 = _interopRequireDefault(_NewsItem);

var _Hero = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Hero");

var _Hero2 = _interopRequireDefault(_Hero);

var _DescriptionWith3Columns = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns");

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _Feature = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Feature");

var _Feature2 = _interopRequireDefault(_Feature);

var _ImageWithOverlayText = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/ImageWithOverlayText");

var _ImageWithOverlayText2 = _interopRequireDefault(_ImageWithOverlayText);

var _Section = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Section");

var _Section2 = _interopRequireDefault(_Section);

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _ProductReleaseNotes = require("@quixeltools/quixel-ui-library/dist/components/megascans/products/ProductReleaseNotes");

var _ProductReleaseNotes2 = _interopRequireDefault(_ProductReleaseNotes);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _softwares = require("redux/modules/softwares");

var _utils = require("utils");

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var page = (0, _glamor.css)({
  maxWidth: (0, _css.unitRem)(46),
  padding: (0, _css.unitRem)(5) + " " + (0, _css.unitRem)(3),

  margin: "auto"
}, (0, _css.minWidth)(_css.breakpoints.xxxlarge)({
  maxWidth: (0, _css.unitRem)(50)
}));

var iconCss = (0, _glamor.css)({
  width: 72,
  height: 72
});

var icon = _react2.default.createElement("img", { className: iconCss, src: "/icons/mixer_icon_2048_preview.png" });

function transformFeed(feed, platform) {
  var notes = {
    icon: icon,
    title: "Quixel Mixer v" + (0, _utils.prettyVersion)(feed.Version) + " for " + (platform === "win" ? "Windows" : "Mac"),
    buttons: [{
      label: "Other Versions",
      to: "/products/mixer"
    }],
    download: {
      label: "Download",
      url: platform === "win" ? feed.Url : feed.UrlMac
    },
    changeLog: Array.isArray(feed.Bullet) ? feed.Bullet : [].concat(feed.Bullet)
  };

  return notes;
}

function getFeed(version, softwares) {
  var updater = softwares.mixerUpdater;
  return updater.filter(function (v) {
    return !!v;
  }).find(function (v) {
    return v.Version == version;
  });
}

var MixerReleaseNotes = (_dec = (0, _redial.provideHooks)({
  fetch: function fetch(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        params = _ref.params;

    var _getState = getState(),
        softwares = _getState.softwares;

    var version = params.version;


    return _bluebird2.default.try(function () {
      if (softwares.mixerUpdater.length === 0) {
        return dispatch((0, _softwares.loadMixerUpdater)());
      }
    }).then(function () {
      var _getState2 = getState(),
          updatedSoftwares = _getState2.softwares;

      if (!getFeed(version, updatedSoftwares)) {
        throw new Error("Failed to get version");
      }
    });
  }
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    softwares: state.softwares
  };
}), _dec(_class = _dec2(_class = function (_React$Component) {
  (0, _inherits3.default)(MixerReleaseNotes, _React$Component);

  function MixerReleaseNotes() {
    (0, _classCallCheck3.default)(this, MixerReleaseNotes);
    return (0, _possibleConstructorReturn3.default)(this, (MixerReleaseNotes.__proto__ || (0, _getPrototypeOf2.default)(MixerReleaseNotes)).apply(this, arguments));
  }

  (0, _createClass3.default)(MixerReleaseNotes, [{
    key: "render",
    value: function render() {
      var _props$params = this.props.params,
          version = _props$params.version,
          platform = _props$params.platform;
      var softwares = this.props.softwares;


      var ver = getFeed(version, softwares);
      var props = transformFeed(ver, platform.toLowerCase());

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "Mixer | Download Mixer " + ver.Version,
          documentDescription: "Download " + props.title + ". Check the release notes for bug fixes and general improvements."
        },
        _react2.default.createElement(
          "div",
          { className: page },
          _react2.default.createElement(_ProductReleaseNotes2.default, props)
        )
      );
    }
  }]);
  return MixerReleaseNotes;
}(_react2.default.Component)) || _class) || _class);
exports.default = MixerReleaseNotes;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/Mixer/ReleaseNotes.jsx
// module id = 2949
// module chunks = 0